import { useState } from 'react'
import CategoryTabs from '../../components/Categories/CategoryTabs'
import CategoryProductList from '../../components/Categories/CategoryProductList'
import { useParams } from 'react-router-dom'
import SHOP_TYPE from '../../constants/shopTypes'
import BackButtonAndTitle from '../../components/retailer-shop/BackButtonAndTitle'
import SeoHelmet from '../../components/common/SeoHelmet'
import useProductCategories from '../../hooks/useProductCategories'

const CategoriesDetailsPage = () => {
  const { categorySlug } = useParams()
  const [activeTab, setActiveTab] = useState('Retail')
  const { getCategoryBySlug } = useProductCategories()

  const category = getCategoryBySlug(categorySlug)
  const categoryName = category?.name || 'Category'

  return (
    <div className="main-container">
      <SeoHelmet
        title={categoryName}
        description={`Browse ${categoryName.toLowerCase()} products from verified retailers and wholesalers in Eastleigh. Find quality ${categoryName.toLowerCase()} items at competitive prices.`}
        keywords={`${categoryName}, Eastleigh ${categoryName.toLowerCase()}, Kenya ${categoryName.toLowerCase()}, ${categoryName.toLowerCase()} marketplace, online shopping`}
        url={`/categories/${categorySlug}`}
      />
      <BackButtonAndTitle title={categoryName} />
      <CategoryTabs activeTab={activeTab} setActiveTab={setActiveTab} />

      {activeTab === 'Retail' && (
        <CategoryProductList categorySlug={categorySlug} shopType={SHOP_TYPE.retail} />
      )}
      {activeTab === 'Wholesale' && (
        <CategoryProductList categorySlug={categorySlug} shopType={SHOP_TYPE.wholesale} />
      )}
    </div>
  )
}

export default CategoriesDetailsPage
